import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { CheckIcon } from 'components/ui/index';
import { useI18n } from 'hooks/use_i18n';
import { getFormLabels, getFormOptions } from 'components/ui/json_form_constants';
import Loader from 'components/ui/loader';

const JsonFormValuesLazy = lazy(() => import('@deecide/redux-json-form').then((module) => ({ default: module.JsonFormValues })));

const JsonValues = ({ translations, schema, source, locale, requestId, slug }) => {
  const { getCurrentLocale, t } = useI18n();
  const currentLocale = getCurrentLocale();
  const localeForForm = locale || currentLocale;
  const _t = (path, params = {}) => t(path, { locale: localeForForm, ...params });

  return (
    <Suspense fallback={<Loader />}>
      <JsonFormValuesLazy
        key={JSON.stringify(source)}
        translations={translations}
        schema={schema}
        locale={localeForForm}
        source={source}
        slug={slug}
        components={{
          true_false: ({ value }) => {
            return <CheckIcon check={value} />;
          },
        }}
        formLabels={getFormLabels(_t)}
        options={getFormOptions(t, currentLocale, requestId)}
      />
    </Suspense>
  );
};

JsonValues.defaultProps = {
  source: {},
};

JsonValues.propTypes = {
  schema: PropTypes.object.isRequired,
  source: PropTypes.object,
};

export default JsonValues;
